<script>
  import { onMount } from "svelte";
  import { addHash, localeOrderBy, slice, loadPersisted, savePersisted } from "../../mjnUtils";
  import Pagination from "./pagination/Pagination.svelte";

  let { http, toastr, search } = $props();

  let records = $state([]);
  let searchText = $state("");
  let sortType = $state(loadPersisted("logs", "sortType", "stamp"));
  let sortReverse = $state(loadPersisted("logs", "sortReverse", true));
  let currentPage = $state(1);
  const itemsPerPage = 11;

  $effect(() => {
    savePersisted("logs", "sortType", sortType);
    savePersisted("logs", "sortReverse", sortReverse);
  });

  onMount(() => {
    http.get("/api/dziennik.php").then(
      (response) => {
        if (response.data.status == 200) {
          records = addHash(response.data.records, "idlog");
        } else {
          toastr.error("Błąd: " + response.data.message);
        }
      },
      () => {
        toastr.error("Błąd połączenia");
      },
    );
  });

  let filteredRecords = $derived(search(records, searchText));
  let sortedRecords = $derived(localeOrderBy(filteredRecords, sortType, sortReverse));
  let totalItems = $derived(filteredRecords.length);
  let numPages = $derived(Math.max(1, Math.ceil(totalItems / itemsPerPage)));
  let pagedRecords = $derived(slice(sortedRecords, itemsPerPage, currentPage));

  $effect(() => {
    searchText;
    currentPage = 1;
  });

  function setSort(field) {
    if (sortType === field) {
      sortReverse = !sortReverse;
    } else {
      sortType = field;
      sortReverse = false;
    }
  }
</script>

<h3><i class="fas fa-book fa-lg"></i>&nbsp;&nbsp;Dziennik zdarzeń
</h3>
<div class="clearfix"></div>
<div class="text-left"><small><i class="fa fa-random" aria-hidden="true"></i>
W tej chwili mamy {records.length} wpisów, {filteredRecords.length} przefiltrowanych poniżej.
</small><p></p></div>

<form>
    <div class="form-group">
      <div class="input-group">
        <div class="input-group-addon"><i class="fas fa-search"></i></div>
        <input type="text" class="form-control input-sm" placeholder="Wyszukaj użytkownika" bind:value={searchText}>
      </div>
    </div>
</form>

<table class="table table-condensed table-hover table-striped">

    <thead class="thead-default">
      <tr>
        <th>
          <a href="#" onclick={(e) => { e.preventDefault(); setSort("idlog"); }}>
          Lp
          {#if sortType == "idlog" && !sortReverse}<span class="fa fa-caret-down"></span>{/if}
          {#if sortType == "idlog" && sortReverse}<span class="fa fa-caret-up"></span>{/if}
          </a>
        </th>
        <th>
          <a href="#" onclick={(e) => { e.preventDefault(); setSort("stamp"); }}>
          Czas rejestracji
          {#if sortType == "stamp" && !sortReverse}<span class="fa fa-caret-down"></span>{/if}
          {#if sortType == "stamp" && sortReverse}<span class="fa fa-caret-up"></span>{/if}
          </a>
        </th>
        <th class="hidden-xs">
          <a href="#" onclick={(e) => { e.preventDefault(); setSort("user"); }}>
          Użytkownik
          {#if sortType == "user" && !sortReverse}<span class="fa fa-caret-down"></span>{/if}
          {#if sortType == "user" && sortReverse}<span class="fa fa-caret-up"></span>{/if}
          </a>
        </th>
        <th class="hidden-xs">
          <a href="#" onclick={(e) => { e.preventDefault(); setSort("ip"); }}>
          IP
          {#if sortType == "ip" && !sortReverse}<span class="fa fa-caret-down"></span>{/if}
          {#if sortType == "ip" && sortReverse}<span class="fa fa-caret-up"></span>{/if}
          </a>
        </th>
        <th class="hidden-xs">
          <a href="#" onclick={(e) => { e.preventDefault(); setSort("akcja"); }}>
          Akcja
          {#if sortType == "akcja" && !sortReverse}<span class="fa fa-caret-down"></span>{/if}
          {#if sortType == "akcja" && sortReverse}<span class="fa fa-caret-up"></span>{/if}
          </a>
        </th>
        <th class="hidden-xs">
          <a href="#" onclick={(e) => { e.preventDefault(); setSort("info"); }}>
          Info
          {#if sortType == "info" && !sortReverse}<span class="fa fa-caret-down"></span>{/if}
          {#if sortType == "info" && sortReverse}<span class="fa fa-caret-up"></span>{/if}
          </a>
        </th>
        <th>
          <a href="#" onclick={(e) => { e.preventDefault(); setSort("status"); }}>
          Status
          {#if sortType == "status" && !sortReverse}<span class="fa fa-caret-down"></span>{/if}
          {#if sortType == "status" && sortReverse}<span class="fa fa-caret-up"></span>{/if}
          </a>
        </th>
        <th class="hidden-xs">
          <a href="#" onclick={(e) => { e.preventDefault(); setSort("skrypt"); }}>
          Wywołanie API
          {#if sortType == "skrypt" && !sortReverse}<span class="fa fa-caret-down"></span>{/if}
          {#if sortType == "skrypt" && sortReverse}<span class="fa fa-caret-up"></span>{/if}
          </a>
        </th>
      </tr>
    </thead>

    <tbody>
      {#each pagedRecords as record (record.idlog)}
      <tr>
        <td>
        {record.idlog}
        </td>
        <td>
        {record.stamp}
        </td>
        <td class="hidden-xs">
        {record.user}
        </td>
        <td class="hidden-xs">
        {record.ip}
        </td>
        <td class="hidden-xs">
        {record.akcja}
        </td>
        <td class="hidden-xs">
        {record.info}
        </td>
        <td>
        {record.status}
        </td>
        <td class="hidden-xs">
        {record.skrypt}
        </td>
      </tr>
      {/each}
    </tbody>

</table>

<Pagination {currentPage} {numPages} onPageChange={(page) => currentPage = page}/>
